import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Checkbox, ListItemButton, Radio, Typography } from '@mui/material';
import { addOpacity } from 'lib/helpers';
import { useCurrencyString } from 'lib/useCurrencyString';
import { IAdjustmentLocalResource } from 'components/order/model/Order';
import { isString } from 'lib/typeInference';

const PREFIX = 'ViewBasketAwardItem';

const classes = {
    rewardPrice: `${PREFIX}rewardPrice`
};

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginRight: 'auto',
    [`& .${classes.rewardPrice}`]: {
        color: addOpacity(theme.palette.text.primary, 0.6)
    }
}));

interface IProps {
    award: IAdjustmentLocalResource;
    onClick: (awardId: string) => void;
    selected?: boolean;
    multi?: boolean;
}

export const ViewBasketAwardItem: React.FC<React.PropsWithChildren<IProps>> = ({
    award,
    onClick,
    selected,
    multi
}) => {
    const getCurrencyString = useCurrencyString();
    const handleRewardClick = React.useCallback(
        () => onClick && isString(award.awardId) && onClick(award.awardId),
        [onClick, award.awardId]
    );
    return (
        <ListItemButton disableGutters onClick={handleRewardClick}>
            <Box display="flex" alignItems="center" width="100%">
                <StyledBox>
                    <Typography>{award.description}</Typography>
                    <Typography className={classes.rewardPrice}>
                        {getCurrencyString(award.totalValue)}
                    </Typography>
                </StyledBox>
                {multi ? <Checkbox checked={selected} /> : <Radio checked={selected} />}
            </Box>
        </ListItemButton>
    );
};
